import { Employee } from "../types/types";
import { get } from "../util/api";

/**
 * 全ての従業員を取得
 */
export const findAllEmployees = async (): Promise<Employee[]> => {
  return await get<Employee[]>("/employees");
};
